import { createSlice } from '@reduxjs/toolkit';

const initialState = { isLoading: false };

const appSlice = createSlice({
	name: 'app',
	initialState,
	reducers: {
		isLoading: (state, action) => {
			return { ...state, isLoading: action.payload };
		}
	}
});

export const { isLoading } = appSlice.actions;
export default appSlice.reducer;
